import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Auth from "routes/authRoute";
import Login from "pages/Login";
import NotFound from "pages/NotFound";
import DailyReport from "pages/DailyReport";

const Root: React.FC = () => {
  return (
    <div className="root-wrapper">
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route path="/" element={<Auth />}>
          <Route path="/" element={<Navigate to="/daily-report" replace />} />

          <Route path="/daily-report" element={<DailyReport />} />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default Root;
